export const languageStoreId = "language";
